import styles from './LegacyModalMediaContent.module.scss';

type Props = {
  /**
   * The content to render.
   */
  children: React.ReactNode;
  /**
   * The rendered close button provided by `Modal`.
   */
  closeButton?: React.ReactNode;
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is deprecated in favor of [ModalDialog](https://zinnia-storybook.zapier.com/?path=/docs/display-modaldialog--docs).</span>
 *
 * @deprecated Use `ModalDialog` instead.
 */
export const LegacyModalMediaContent = (props: Props) => {
  return (
    <div className={styles.root} data-zds>
      {props.children}
      {props.closeButton && (
        <div className={styles.closeButton} data-zds>
          {props.closeButton}
        </div>
      )}
    </div>
  );
};
